import { Loader } from '@mantine/core';

import { Avatar } from '../../../../../../../components/Atoms';
import { LOADER_COLOR_BY_STATUS } from '../InstanceListTable.utils';

interface InstanceAvatarProps {
    hostname: string;
    status: string;
}

export default function InstanceAvatar({ hostname, status }: InstanceAvatarProps) {
    const loaderColor = LOADER_COLOR_BY_STATUS[status];

    if (loaderColor) {
        return (
            <div className="w-12 h-12 rounded-md flex justify-center items-center bg-page border-[0.5px] border-line overflow-hidden">
                <Loader type="oval" color={loaderColor} size={30} />
            </div>
        );
    }

    return (
        <div className={status === 'stopped' ? 'opacity-50' : ''}>
            <Avatar value={hostname} size="52" />
        </div>
    );
}
